<template>
  <el-dialog custom-class="collect-corporate-result-detail-container dialog-size-large"
             title="詳細情報"
             :visible="visible"
             :append-to-body="true"
             top="0"
             :modal="false"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="collect-corporate-result-detail-container-inner">
      <fixed-header-table :fixed="corpDetail && corpDetail.data != null" style="max-height: 480px;"
                          class="collect-corporate-result-detail">
        <tr slot="header">
          <th v-for="column in displayColumns">{{column.label}}</th>
        </tr>
        <tr>
          <td v-for="column in displayColumns">
            <template v-if="column.value === 'hp'">
              <a :href="formatNumberCell(corpDetail.data, column)" target="_blank">{{formatNumberCell(corpDetail.data,
                column)}}</a>
            </template>
            <template v-else>
              {{formatNumberCell(corpDetail.data, column)}}
            </template>
          </td>
        </tr>
      </fixed-header-table>
      <h3 style="margin-top: 16px; flex-shrink: 0;">地図情報</h3>
      <div style="display: flex; justify-content: center; margin-top: 6px;">
        <iframe :src="getGoogleMapSrc()" width="100%" height="300" frameborder="0" style="border:0"></iframe>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button type="info" class="large" style="width: 320px; height: 50px;" @click="onClickDownload">ダウンロード
      </el-button>
    </div>
  </el-dialog>
</template>

<script lang="js">
import FormatUtil from '../../../utils/format'
import WebApiClient, { GetDataCollectionCorporationDetailResult } from '../../../api/web'
import DownloadUtil from '../../../utils/donwload'

export default {
  name: 'CollectCorporationDetailResultDialogCmp',
  props: {
    corpCode: '',
    corpDetail: GetDataCollectionCorporationDetailResult
  },
  computed: {
    ignoreFormatNumberColumns () {
      return ['法人番号']
    },
    displayColumns () {
      return [
        { 'value': 'corpName', 'label': '名称' },
        { 'value': 'postalCode', 'label': '郵便番号' },
        { 'value': 'location', 'label': '国内所在地' },
        { 'value': 'tel', 'label': 'TEL' },
        { 'value': 'fax', 'label': 'FAX' },
        { 'value': 'hp', 'label': 'HP' }
      ]
    }
  },
  data () {
    return {
      visible: true

    }
  },
  methods: {
    formatNumberCell (corporation, column) {
      let result = null

      const value = column.value
      for (let key of Object.keys(corporation)) {
        if (value === key) {
          if (this.ignoreFormatNumberColumns.indexOf(value) !== -1) {
            result = FormatUtil.formatNumber(corporation[key])
            break
          } else {
            result = corporation[key]
            break
          }
        }
      }
      return result || '-'
    },
    getGoogleMapSrc () {
      const latitude = this.corpDetail.data.geolocation.latitude
      const longitude = this.corpDetail.data.geolocation.longitude
      return `https://maps.google.com/maps?f=q&q=${latitude},${longitude}&z=17&output=embed`
    },
    onClickDownload () {
      const param = {
        corpName: this.corpDetail.data.corpName,
        corpType: this.corpDetail.data.corpType,
        location: this.corpDetail.data.location,
        postalCode: this.corpDetail.data.postalCode,
        tel: this.corpDetail.data.tel,
        fax: this.corpDetail.data.fax,
        hp: this.corpDetail.data.hp,
        latitude: this.corpDetail.data.geolocation.latitude,
        longitude: this.corpDetail.data.geolocation.longitude
      }

      return WebApiClient.postDataCollectionCorporationDownload(this, this.corpCode, param).then(response => {
        const fileName = DownloadUtil.getFileNameFromContentDisposition(response.headers['content-disposition'])
        DownloadUtil.downloadCsvBlob(response.data, fileName)
      })
    }
  }
}

</script>

<style scoped>
  .collect-corporate-result-detail-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .collect-corporate-result-detail.table-wrapper.fixed {
    border-bottom: none;
    border-right: none;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .collect-corporate-result-detail.table-wrapper.fixed >>> .table-header > thead {
    padding-right: 0;
  }

  .collect-corporate-result-detail.table-wrapper.fixed >>> .table-body {
    overflow-y: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/data-collect/dialogs/collect-corporation-detail-result.vue